import { useTableKeyboardNavigation } from '@progress/kendo-react-data-tools';
import { GRID_COL_INDEX_ATTRIBUTE } from '@progress/kendo-react-grid';
const useTdProps = ({ id, colSpan, ariaColumnIndex, isSelected, columnIndex, }) => {
    const navigationAttributes = useTableKeyboardNavigation(id);
    return {
        colSpan,
        'role': 'gridcell',
        'aria-colindex': ariaColumnIndex,
        'aria-selected': isSelected,
        [GRID_COL_INDEX_ATTRIBUTE]: columnIndex,
        ...navigationAttributes,
    };
};
export { useTdProps };
//# sourceMappingURL=use-td-props.js.map